<template>
    <span class="name-no" :class="{ 'name-no--inline': inline }">
        <span class="name-no__name">{{ name }}</span>
        <small v-if="no" class="name-no__no">{{ no }}</small>
    </span>
</template>

<script>
    /*
     * Two-line "Name / No" block for v-select #option and #selected-option slots.
     *
     *   <template #option="o"><NameNoOption :name="o.name" :no="o.no" /></template>
     */
    export default {
        props: {
            name: {
                type: [String, Number],
                default: ''
            },
            no: {
                type: [String, Number],
                default: ''
            },
            inline: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .name-no {
        display: block;
        min-width: 0;
    }

    .name-no__name {
        display: block;
        font-weight: 600;
        line-height: 1.2;
        white-space: normal;
    }

    .name-no__no {
        display: block;
        line-height: 1.1;
        font-size: 0.857rem;
        opacity: 0.75;
    }

    .name-no--inline {
        display: inline-flex;
        align-items: baseline;
        gap: 0.35rem;

        .name-no__name,
        .name-no__no {
            display: inline;
        }
    }
</style>
